class ProductCard extends HTMLElement {
  constructor() {
    super()
    this.boundHandleVariantChange = this.handleVariantChange.bind(this)
    this.labelHandlers = new Map()
  }

  connectedCallback() {
    this.productCardElement = this
    this.productId = this.getAttribute('data-product-id')
    this.sectionId = this.getAttribute('data-section-id')
    this.formElement = this.querySelector('#variant-switcher')
    this.productPriceElement = this.querySelector('[data-product-price]')
    this.productCardMediaSlider = this.querySelector('.product-card__media-slider')
    this.mediaElement = this.querySelector('.product-card__media img')
    this.quickAddVariantIdElements = this.querySelectorAll('.quick-add form [name="id"]')
    this.quickAddButtons = this.querySelectorAll('.quick-add button[data-variant-id], .quick-add form button[type="submit"]')
    this.dynamicQuickAddContainer = this.querySelector('.quick-add[data-dynamic-quick-add="true"]')
    this.variantIdElement = this.querySelector('form [name="id"]')
    this.hoverMediaElement = this.querySelector('.product-card__secondary') || this.querySelector('secondary-media')
    this.allProductCardBottomElements = this.querySelectorAll('.product-card__bottom')
    this.badgesElement = this.querySelector('.product-card__media .badges')

    if (!this.formElement) return

    this.allInputElement = this.formElement.querySelectorAll('input[type="radio"], input[type="checkbox"]')

    this.addEventListener('change', this.boundHandleVariantChange, true)

    this.allInputElement.forEach((input) => {
      const labelElement = this.formElement.querySelector('label[for="' + input.id + '"]')

      const handleUpdateColor = (event) => {
        const target = event.target
        const groupElement = target.closest('.swatches')
        const groupInputElement = groupElement.querySelectorAll('input[type="radio"], input[type="checkbox"]')
        const groupLabelElement = groupElement.querySelectorAll('label')

        groupInputElement.forEach((inputElement) => {
          inputElement.classList.remove('selected')
          inputElement.checked = false
        })

        groupLabelElement.forEach((labelElement) => {
          labelElement.classList.remove('selected')
        })

        target.classList.add('selected')

        const newInputElement = Array.from(this.allInputElement).find((input) => input.value === target.dataset.value)
        newInputElement.checked = true

        this.handleVariantChange()
        this.updateSwatchAvailability()
      }

      labelElement.addEventListener('mouseenter', (event) => handleUpdateColor(event) )
    })

    this.updateSwatchAvailability()

    this.allProductCardBottomElements.forEach((productCardBottomElement) => {
      this.carousel = new Swiper(productCardBottomElement.querySelector('.swatches-slider'), {
        direction: 'horizontal',
        slidesPerView: 'auto',
        breakpoints: {
          320: {
            spaceBetween: 8,
            slidesPerGroupAuto: true,
          },
          768: {
            spaceBetween: 12,
            slidesPerGroup: 4,
          },
        },
        loop: false,
        navigation: {
          nextEl: productCardBottomElement.querySelector('.swiper-button-next'),
          prevEl: productCardBottomElement.querySelector('.swiper-button-prev'),
        },
        on: {
          afterInit: (swiper) => {
            if (productCardBottomElement.querySelector('.swiper-button-next').classList.contains('swiper-button-disabled') && productCardBottomElement.querySelector('.swiper-button-prev').classList.contains('swiper-button-disabled')) {
              productCardBottomElement.querySelector('.swiper-button-next').classList.add('swiper-button-not-needed')
              productCardBottomElement.querySelector('.swiper-button-prev').classList.add('swiper-button-not-needed')
            } else {
              productCardBottomElement.querySelector('.swiper-button-next').classList.remove('swiper-button-not-needed')
              productCardBottomElement.querySelector('.swiper-button-prev').classList.remove('swiper-button-not-needed')
            }

            // Scroll to the selected variant
            const allInputElements = productCardBottomElement.querySelectorAll('.swiper-wrapper input[type="radio"]')
            const indexOfSelectedVariant = Array.from(allInputElements).findIndex((input) => input.checked)

            if (indexOfSelectedVariant !== -1 && indexOfSelectedVariant !== 0) {
              swiper.slideTo(indexOfSelectedVariant, 0, false)
            }
          }
        }
      });
    });
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.boundHandleVariantChange, true)
    this.labelHandlers.forEach((handler, labelElement) => {
      labelElement.removeEventListener('mouseenter', handler)
    })
    this.labelHandlers.clear()
  }

  handleVariantChange = () => {
    if (!this.formElement) return

    const previousActiveVariantId = this.formElement.getAttribute('[name="id"]')

    this.setAttribute('aria-busy', 'true')
    this.updateOptions()
    this.getSelectedVariant()

    if (previousActiveVariantId && previousActiveVariantId === String(this.currentVariant?.id)) {
      this.setAttribute('aria-busy', 'false')
    } else if (this.currentVariant) {
      
      this.updateProductButton()
      this.previousActiveVariant = this.currentVariant
    } else {
      this.setAttribute('aria-busy', 'false')
    }
  }

  updateOptions = () => {
    const optionGroups = this.formElement
      ? Array.from(this.formElement.querySelectorAll('.swatches'))
      : []
    this.options = optionGroups.map((group) => {
      const checked = group.querySelector('input:checked')
      return checked?.value
    })
  }

  getSelectedVariant = () => {
    const variantData = this.getVariantData()

    if (!variantData || !this.options) return
    
    this.currentVariant = variantData.find((variant) =>
      variant.options?.every((option, index) => {
        return this.options[index]?.replace(' ', '').toLowerCase() == option?.replace(' ', '').toLowerCase()
      })
  )

    if (this.currentVariant && this.getHoverVariantData()) {
      const hoverVariant = this.getHoverVariantData().find(
        (variant) => variant.id === this.currentVariant.id
      )
      if (hoverVariant?.hoverImage) {
        this.currentVariant.hoverImage = hoverVariant.hoverImage
      }
    }
  }

  getVariantData = () => {
    const script = this.querySelector('script#BasicProductInfo, script[id="BasicProductInfo"]')
    if (!script?.textContent) return null

    this.variantData = this.variantData || JSON.parse(script.textContent)
    return this.variantData
  }

  getHoverVariantData = () => {
    const script = this.querySelector('script#ProductHoverImages, script[id="ProductHoverImages"]')
    if (!script?.textContent) return null

    this.extendedVariantData = this.extendedVariantData || JSON.parse(script.textContent)
    return this.extendedVariantData
  }

  getBadgeVariantData = () => {
    const script = this.querySelector('script#ProductBadgeInfo, script[id="ProductBadgeInfo"]')
    if (!script?.textContent) return null

    this.badgeVariantData = this.badgeVariantData || JSON.parse(script.textContent)
    return this.badgeVariantData
  }

  updateVariantBadges = () => {
    if (!this.currentVariant) return

    const badgeVariantData = this.getBadgeVariantData()
    if (!badgeVariantData) return

    const matchingBadgeData = badgeVariantData.find((variant) => Number(variant?.id) === Number(this.currentVariant.id))
    const badgesHtml = matchingBadgeData?.badgesHtml
    if (!badgesHtml) return

    const currentBadgesElement = this.querySelector('.product-card__media .badges')
    if (!currentBadgesElement) return

    currentBadgesElement.outerHTML = badgesHtml
    this.badgesElement = this.querySelector('.product-card__media .badges')
  }

  updateSwatchAvailability = () => {
    const variantData = this.getVariantData()
    if (!variantData || !this.formElement) return

    const allGroups = Array.from(this.formElement.querySelectorAll('.swatches'))

    const selectedValues = allGroups.map(group => {
      const checked = group.querySelector('input:checked')
      return checked?.value || null
    })

    allGroups.forEach((group, groupIndex) => {
      group.querySelectorAll('label.swatch').forEach(label => {
        const value = label.dataset.value
        const input = this.formElement.querySelector(`input[id="${label.htmlFor}"]`)

        const testOptions = selectedValues.map((sel, i) => i === groupIndex ? value : sel)

        const isAvailable = variantData.some(variant =>
          variant.available &&
          variant.options.every((opt, i) =>
            testOptions[i] == null ||
            opt?.replace(' ', '').toLowerCase() === testOptions[i]?.replace(' ', '').toLowerCase()
          )
        )

        label.classList.toggle('sold-out', !isAvailable)
        input?.classList.toggle('disabled', !isAvailable)
      })
    })
  }

  updateProductButton = () => {
    if (!this.currentVariant) return

    const allLinks = this.querySelectorAll('a[href*="/products/"]')

    allLinks.forEach((link) => {
      const newUrl = new URL(link.href)
      newUrl.searchParams.set('variant', this.currentVariant.id)
      link.setAttribute('href', newUrl.toString())
    })
    
    if (this.variantIdElement) {
      this.variantIdElement.value = this.currentVariant.id
    }

    this.quickAddVariantIdElements.forEach((variantIdInput) => {
      variantIdInput.value = this.currentVariant.id
    })

    this.quickAddButtons.forEach((button) => {
      button.dataset.variantId = String(this.currentVariant.id)
      button.disabled = !this.currentVariant.available
    })

    if (this.dynamicQuickAddContainer) {
      this.dynamicQuickAddContainer.classList.toggle('hidden', !this.currentVariant.available)
      this.dynamicQuickAddContainer.classList.toggle('flex', this.currentVariant.available)
    }

    this.updateVariantBadges()

    if (this.mediaElement && this.currentVariant.featured_image) {      
      this.mediaElement.setAttribute('src', this.currentVariant.featured_image.src)
      this.mediaElement.setAttribute('srcset', this.currentVariant.featured_image.src)

      const targetImage = new Image()
      targetImage.src = this.currentVariant.featured_image.src
      targetImage.onload = () => this.setAttribute('aria-busy', 'false')
    } else {
      this.setAttribute('aria-busy', 'false')
    }

    if (this.currentVariant.hoverImage && this.currentVariant.hoverImage !== 'undefined') {
      if (this.hoverMediaElement) {
        const pictureElement = this.hoverMediaElement?.querySelector('picture')
        const imageElement = pictureElement?.querySelector('img')

        if (imageElement) {
          imageElement?.setAttribute('src', this.currentVariant.hoverImage)
          imageElement?.setAttribute('srcset', this.currentVariant.hoverImage)
        }
      } else {
        const templateElement = this.productCardElement.querySelector('template')
        const templateContentClone = templateElement?.content?.cloneNode(true)
        const newImageElement = templateContentClone?.querySelector('img')
        
        newImageElement?.setAttribute('src', this.currentVariant.hoverImage)
        newImageElement?.setAttribute('srcset', this.currentVariant.hoverImage)

        // Set the new hover image element in the HTML
        if (templateContentClone) {
          //Remove previous set hover image elements.
          this.productCardMediaSlider?.querySelectorAll('.product-card__secondary')?.forEach((element) => {
            element.remove()
          })

          this.productCardMediaSlider?.appendChild(templateContentClone)
        }

        // Add the hide on hover class to the first image element
        this.productCardMediaSlider?.querySelector('.product-card__media')?.classList?.add('hide-on-hover')
      }
    } else {
      // Remove the hide on hover class and remove the hover element.
      if (this.productCardMediaSlider?.querySelector('.product-card__secondary')) {
        this.productCardMediaSlider?.removeChild(this.productCardMediaSlider.querySelector('.product-card__secondary'))
      }
      this.productCardMediaSlider?.querySelector('.product-card__media')?.classList?.remove('hide-on-hover')
    }
  }
}

if (customElements.get('product-card') === undefined) {
  customElements.define('product-card', ProductCard)
}